import { gql, useLazyQuery, useQuery } from '@apollo/client'
import { ProgramTrainer } from '../../models'

const GET_TRAINER = gql`
  query GetProgramTrainer($id: String!) {
    programTrainer(id: $id) {
      id
      name
      active
    }
  }
`

interface TrainerData {
  programTrainer: ProgramTrainer
}

export const useProgramTrainer = () => {
  const [get, { loading, error, data }] = useLazyQuery<TrainerData>(GET_TRAINER, {
    fetchPolicy: 'network-only',
  })

  const getProgramTrainer = (id: string) => {
    get({
      variables: {
        id: id,
      },
    })
  }

  const trainer = data?.programTrainer || undefined
  return { getProgramTrainer, loading, error, trainer }
}
